/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Ready, InProgress, DeleteIcon, Awaiting, DefaultIcon } from 'assets/icons';
import * as S from './AppStatus.styled';
import { routes } from 'config';
import { appStatuses } from 'constants';
import { CustomTooltip, Loader } from 'components';
import { FixUrlTooltip } from './FixUrlTooltip';
import { useSignal, useComputed } from '@preact/signals-react';

export const FixUrlComponent = ({ pba_number, pba_id }) => {
  const [open, setIsOpen] = useState(false);
  const tolTipRef = useRef();
  const showLoader$ = useSignal(false);

  const handleClickOutside = (event) => {
    console.log('handleClickOutside');
    if (tolTipRef.current && tolTipRef.current.contains(event.target)) return;
    if (open && tolTipRef.current && !tolTipRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleScroll = () => {
    console.log('handleScroll');
    setIsOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('click', handleClickOutside, true);
      window.addEventListener('scroll', handleScroll, false);
    } else {
      document.removeEventListener('click', handleClickOutside, true);
      window.removeEventListener('scroll', handleScroll, false);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      window.removeEventListener('scroll', handleScroll, false);
    };
  }, [open]);

  return (
    <>
      {showLoader$.value && <Loader.Global delay={100} />}
      <S.StatusWrapp>
        <DefaultIcon style={{ fill: 'red' }} />
        <CustomTooltip
          isOpen={open}
          style={{ marginLeft: '4px' }}
          text={
            <FixUrlTooltip
              pba_number={pba_number}
              setIsOpen={setIsOpen}
              ref={tolTipRef}
              pba_id={pba_id}
              showLoader$={showLoader$}
            />
          }
          content={
            <span style={{ color: '#3B89F6' }} onClick={() => setIsOpen(true)}>
              Store URL
            </span>
          }
        />
        <span>information is missing.</span>
      </S.StatusWrapp>
    </>
  );
};
